package one.healthium.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class SavedContentQueries(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver) {
  public fun <T : Any> selectByType(saveType: String, mapper: (
    id: String,
    contentId: String,
    contentType: String,
    title: String?,
    description: String?,
    thumbUrl: String?,
    saveType: String,
    savedAt: Long,
  ) -> T): Query<T> = SelectByTypeQuery(saveType) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getString(5),
      cursor.getString(6)!!,
      cursor.getLong(7)!!
    )
  }

  public fun selectByType(saveType: String): Query<SavedContentEntity> = selectByType(saveType, ::SavedContentEntity)

  /**
   * @return The number of rows updated.
   */
  public suspend fun insert(savedContentEntity: SavedContentEntity): Long {
    val result = driver.execute(-225_508_444, """INSERT OR REPLACE INTO savedContentEntity (id, contentId, contentType, title, description, thumbUrl, saveType, savedAt) VALUES (?, ?, ?, ?, ?, ?, ?, ?)""", 8) {
          var parameterIndex = 0
          bindString(parameterIndex++, savedContentEntity.id)
          bindString(parameterIndex++, savedContentEntity.contentId)
          bindString(parameterIndex++, savedContentEntity.contentType)
          bindString(parameterIndex++, savedContentEntity.title)
          bindString(parameterIndex++, savedContentEntity.description)
          bindString(parameterIndex++, savedContentEntity.thumbUrl)
          bindString(parameterIndex++, savedContentEntity.saveType)
          bindLong(parameterIndex++, savedContentEntity.savedAt)
        }.await()
    notifyQueries(-225_508_444) { emit ->
      emit("savedContentEntity")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun deleteById(id: String): Long {
    val result = driver.execute(1_980_980_104, """DELETE FROM savedContentEntity WHERE id = ?""", 1) {
          var parameterIndex = 0
          bindString(parameterIndex++, id)
        }.await()
    notifyQueries(1_980_980_104) { emit ->
      emit("savedContentEntity")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun deleteRecentlyOldEntries(
    saveType: String,
    saveType_: String,
    `value`: Long,
  ): Long {
    val result = driver.execute(440_172_775, """
        |DELETE FROM savedContentEntity
        |WHERE (saveType = ? AND id NOT IN (
        |    SELECT id FROM savedContentEntity
        |    WHERE saveType = ?
        |    ORDER BY savedAt DESC
        |    LIMIT ?
        |))
        """.trimMargin(), 3) {
          var parameterIndex = 0
          bindString(parameterIndex++, saveType)
          bindString(parameterIndex++, saveType_)
          bindLong(parameterIndex++, value)
        }.await()
    notifyQueries(440_172_775) { emit ->
      emit("savedContentEntity")
    }
    return result
  }

  private inner class SelectByTypeQuery<out T : Any>(
    public val saveType: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("savedContentEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("savedContentEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(-442_358_536, """SELECT savedContentEntity.id, savedContentEntity.contentId, savedContentEntity.contentType, savedContentEntity.title, savedContentEntity.description, savedContentEntity.thumbUrl, savedContentEntity.saveType, savedContentEntity.savedAt FROM savedContentEntity WHERE saveType = ? ORDER BY savedAt DESC""", mapper, 1) {
      var parameterIndex = 0
      bindString(parameterIndex++, saveType)
    }

    override fun toString(): String = "SavedContent.sq:selectByType"
  }
}
